/* eslint-env browser */
/* Inline script runs in the browser; SSR only stringifies this module. */

/** Polyfill bundle (v3 trims by User-Agent when fetched). */
export const POLYFILL_SCRIPT_SRC =
  'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?version=4.8.0&features=default%2Ces2023%2Ces2022%2CstructuredClone';

/**
 * Runs during initial HTML parse. Serialized with `toString()` into an inline `<script>` in the
 * HTML response (`head().scripts`). `u` is passed as the IIFE argument so the serialized function
 * is self-contained after bundling.
 *
 * Uses `document.write` so the loader runs before parser-visible module scripts (deferred).
 * Dynamic `createElement('script')` defaults to async and can lose the race to Vite bundles.
 */
export function runPolyfillGate(u: string): void {
  const p = Array.prototype;

  // Gate = conservative: any missing probe loads the CDN bundle. Add probes only for APIs
  // the app (or dependencies) actually need. Safe pattern: `typeof x === 'function'` on
  // globals or `.prototype` so old engines do not throw during feature detection.
  //
  // More examples (uncomment / copy when needed):
  //   typeof Map.groupBy === 'function'
  //   typeof Set.prototype.difference === 'function'
  //   typeof String.prototype.isWellFormed === 'function' && typeof String.prototype.toWellFormed === 'function'
  //   typeof ArrayBuffer.prototype.transfer === 'function'
  if (
    // ES2023 — array change methods
    typeof p.toSorted === 'function' &&
    typeof p.toReversed === 'function' &&
    typeof p['with'] === 'function' &&
    typeof p.findLast === 'function' &&
    typeof p.findLastIndex === 'function' &&
    // ES2022 — common "baseline" gaps on older WebKit
    typeof Object.hasOwn === 'function' &&
    typeof structuredClone === 'function'
  ) {
    return;
  }
  // Using document.write here on purpose to ensure it runs immediately before the main bundle
  // oxlint-disable-next-line typescript/no-deprecated
  document.write(
    '<script crossorigin="anonymous" src="' +
      u.split('&').join('&amp;') +
      '"' +
      '>' +
      '</scr' +
      'ipt>',
    /**
     * **Why `'</scr' + 'ipt>'`:** The HTML parser does not understand JavaScript. For inline script
     * text it scans for the literal substring `</script>` and ends the element there—even if that
     * sequence would sit inside a JS string. Splitting avoids terminating the host `<script>` early.
     * The string passed to `document.write` still becomes a real `</script>` in the *injected* markup.
     **/
  );
}

/** Serialized gate for `head().scripts` (inline bootstrap in the HTML document). */
export function getPolyfillGateInlineScript(): string {
  return `(${runPolyfillGate.toString()})(${JSON.stringify(POLYFILL_SCRIPT_SRC)});`;
}
